import React from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Input, Row, Col, Tabs, Button } from 'antd';
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
import styles from './AddGroup.less';
import DeviceGroupForm from '../../components/DeviceGroup/DeviceSearchForm';
import DeviceSearchTable from '../../components/DeviceGroup/DeviceSearchTable';
import DeviceSelectedTable from '../../components/DeviceGroup/DeviceSelectedTable';
import history from '@/lib/history';
import { formItemLayout } from '../../const/FormConst';

@inject('addGroupStore')
@observer
class AddGroupComp extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillUnmount() {
    this.props.addGroupStore.searchDeviceArr = [];
    this.props.addGroupStore.selectedDeviceArr = [];
    this.props.addGroupStore.selectedRowKeys = [];
    this.props.addGroupStore.selectedDevicePageSize = 10;
    this.props.addGroupStore.searchDevicePageSize = 10;
    this.props.form.resetFields();
  }
  handleSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        let formData = new FormData();
        const deviceId = [...this.props.addGroupStore.selectedDeviceArr].map(
          item => item.device_id
        );
        formData.append('tag_name', value.tag_name);
        formData.append('tag_memo', value.tag_memo);
        formData.append('device_id', deviceId.join(','));
        this.props.addGroupStore
          .postTag(formData)
          .then(() => history.push('/device/group'));
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className={styles.addGroupContainer}>
        <div className={styles.top}>
          <div className={styles.title}>新建设备分组</div>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <Row>
              <Col span={8}>
                <FormItem {...formItemLayout} label="分组名称">
                  {getFieldDecorator('tag_name', {
                    rules: [{ required: true, message: '请填写分组名称!' }]
                  })(<Input placeholder="分组名称" />)}
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem {...formItemLayout} label="分组描述">
                  {getFieldDecorator('tag_memo', {
                    rules: [{ required: true, message: '请填写分组描述!' }]
                  })(<Input placeholder="分组描述" />)}
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
        <div className={styles.searchContainer}>
          <DeviceGroupForm />
        </div>
        <div className={styles.tabsContainer}>
          <Tabs defaultActiveKey="1">
            <TabPane tab="搜索结果" key="1" className={styles.btnContainer}>
              <DeviceSearchTable />
              <Button
                onClick={this.handleSubmit}
                className={styles.btn}
                type="primary"
              >
                保存新分组
              </Button>
            </TabPane>
            <TabPane tab="选中设备" key="2" className={styles.btnContainer}>
              <DeviceSelectedTable />
              <Button
                onClick={this.handleSubmit}
                className={styles.btn}
                type="primary"
              >
                保存新分组
              </Button>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}
const AddGroup = Form.create()(AddGroupComp);
export default AddGroup;



// WEBPACK FOOTER //
// ./src/pages/DeviceGroup/AddGroup.js